import store from "app/api/redux/store";

export default () =>
  !store.getState().auth.token
    ? sessionStorage.getItem("token")
    : store.getState().auth.token;
